<template>
   <div class="crud-wrapper">
      <crud-toolbar :isBlocked="formData.blocked" :modal-mode="modalMode" :new-state="newState"
                    :title="modalTitle" @onCommand="toolbarCommand"
                    showBlock></crud-toolbar>

        <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">
            <div>
                <v-slide-y-transition>
                    <v-card :class="{alert: formStatus.alert}" class="form-status-card" flat v-if="formStatus.text">
                    <v-card-text class="caption py-2">
                        {{formStatus.text}}
                    </v-card-text>
                    </v-card>
                </v-slide-y-transition>

                <v-layout row wrap>
                    <a-text-field :error-messages="federalError" autofocus
                                label="CPF/CNPJ" ref="atfCPF" :append-icon="(formData.personType==='A') ? 'fas fa-mobile-alt' : ''"
                                sm6 v-mask="['###.###.###-##','##.###.###/####-##']" v-model="formData.federalId"
                                validate="required,cpf_cnpj"></a-text-field>
                    <a-text-field label="Celular" sm6 v-mask="['(##) ####-####', '(##) #####-####']"
                                v-model="formData.mobileNumber"></a-text-field>

                    <a-text-field label="Código Único do Afiliado" readonly :append-outer-icon="'content_copy'" :append-outer-icon-cb="copyReferral" sm6 v-model="formData.referralCode"></a-text-field>
                    <a-select-field label="Tipo" sm6 v-model="formData.roleId" obj="role" validate="required" :filter-by="{id: [5,6]}"></a-select-field>

                    <a-text-field label="Nome" text-transform="capitalize" v-model="formData.name" sm8
                                validate="required"></a-text-field>

                    <a-date-field :birth-date="{minAge: 18, maxAge:75}" :label="birthLabel" dateFormat="DD/MM/YYYY"
                                sm4 v-model="formData.birth" validate="dateDMY"></a-date-field>

                    

                    <a-text-field label="CEP" mask="#####-###" v-model="formData.zipcode" sm4></a-text-field>
                    <a-text-field label="Endereço" v-model="formData.address" sm8></a-text-field>
                    <a-select-field display-key="code" label="Estado" obj="countryState" sm6 v-model="formData.state"></a-select-field>
                    <a-text-field label="Cidade" v-model="formData.city" sm6></a-text-field>
                    <v-flex pb-1 xs12>
                        <label class="subheading grey--text">Acesso</label>
                     </v-flex>
                     <a-text-field label="Email" v-model="formData.mainEmail" sm12></a-text-field>
                     <a-text-field label="Senha Temporária de Acesso" v-model="formData.firstPin" sm12></a-text-field>

                    <v-flex pb-1 xs12>
                        <label class="subheading grey--text">Conta para Pagamento</label>
                     </v-flex>
                    <a-autocomplete-field :validate="isRequired" @change="bankPayChange" allow-new autoTrigger label="Banco" obj="bank" sm7
                                           v-model="formData.bankId">
                        <template slot="content" slot-scope="{data}">
                           {{`${data.bankNo} - ${data.name}`}}
                        </template>
                     </a-autocomplete-field>
                     <a-text-field :validate="isRequired" label="Agência" sm5 v-mask="['###X', '####-X']"
                                   v-model="formData.branchNo"></a-text-field>
                    <a-select-field hide-details label="Tipo de Conta" sm6 v-model="formData.acctType" :suggestions="acctTypes"></a-select-field>
                     <a-text-field :validate="isRequired" label="Conta Corrente" sm6
                                   v-mask="['###-X', '####-X', '#####-X', '######-X','#######-X',
                           '########-X','#########-X','##########-X','###########-X','############-X']"
                                   v-model="formData.acctNo"></a-text-field>
                     <a-text-field v-if="isBankPayCaixa" label="Operação" sm6 v-mask="['###']" v-model="formData.opNo"></a-text-field>
                    <div class="invalid-account" v-if="formData.isBlocked">
                        <div>
                            <i class="fas fa-exclamation-triangle"></i>
                            <p>Conta inativa ou bloqueada.</p>
                        </div>

                        <div class="reason" v-if="formData.notes">
                            <p>Motivo:</p>
                            <p>{{ formData.notes }}</p>
                        </div>

                        <div>
                            <p>Corrija os dados da conta para que seja desbloqueada e ativada.</p>
                        </div>
                    </div>
                </v-layout>
            </div>
        
            <template slot="rightContent" style="width: 100%">
                <h4>Ações</h4>
                
                <div style="display: flex; flex-direction: row;">
                    <button class="btn btn-resend-email" v-on:click="resendEmail($event)">
                        <v-progress-circular v-if="loadingSendEmail" size="20" color="white" indeterminate="indeterminate"></v-progress-circular>
                        <p style="margin: 0;" v-else>Reenviar email de acesso</p>
                    </button>
                    <button class="btn btn-generate-links" v-on:click="getReferralCode($event)" :disabled="referralCode">
                        <v-progress-circular v-if="loadingGenerateLinks" size="20" color="white" indeterminate="indeterminate"></v-progress-circular>
                        <p style="margin: 0;" v-else>Gerar links de indicações</p>
                    </button>
                </div>
                
                <div class="links" v-if="referralCode">
                    <h5>Links de indicações</h5>
                    <div class="link-card" v-on:click="copyLink('https://consigmais.page.link/'+referralCode)">
                        <div>
                            <p class="link-title">Consignado</p>
                            <p class="link">https://consigmais.page.link/{{referralCode}}</p>
                        </div>
                        <div>
                            <v-icon small class="link-copy">fas fa-copy</v-icon>
                            <v-icon small class="link-qrcode" v-on:click.stop="toggleModal('consignado', 'https://consigmais.page.link/'+referralCode)">fas fa-qrcode</v-icon>
                        </div>
                    </div>
                    <div class="link-card" v-on:click="copyLink('https://fgts.consigmais.com.br/'+referralCode)">
                        <div>
                            <p class="link-title">FGTS</p>
                            <p class="link">https://fgts.consigmais.com.br/{{referralCode}}</p>
                        </div>
                        <div>
                            <v-icon small class="link-copy">fas fa-copy</v-icon>
                            <v-icon small class="link-qrcode" v-on:click.stop="toggleModal('fgts', 'https://fgts.consigmais.com.br/'+referralCode)">fas fa-qrcode</v-icon>
                        </div>
                    </div>
                </div>
            </template>

            <div class="modal-container-qrcode hidden">
                <div class="modal-content-qrcode">
                    <div class="modal-content-header">
                        <h4>QRCode</h4>
                        <v-icon v-on:click.stop="toggleModal()">fas fa-times</v-icon>
                    </div>
                    <div class="qr-code affiliate-qr-code"></div>
                    <button class="download-qrcode" v-on:click="download($event)">Baixar</button>
                </div>
            </div>
        </crud-form>
   </div>
</template>

<script>
    import QrCreator from 'qr-creator';
    import ACombobox from '@consigmais-team/vue-common/components/ACombobox.vue';
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

    export default CrudFormClass.extend({
  components: { ACombobox },
        name: 'affiliateForm',
        
        data: () => ({
            title: 'Afiliado',
            formName: 'affiliateForm',

            federalError: null,

            referralCode: null,

            loading: false,
            loadingSendEmail: false,
            loadingGenerateLinks: false,

            formStatus: {},
            selectedProduct: null,

            formData: {
                id: null,
                federalId: null,
                roleId: null,
                name: null,
                birth: null,

                address: null,
                addressNumber: null,
                address2: null,
                district: null,
                city: null,
                state: null,
                zipcode: null,

                mobileNumber: null,
                mainEmail: null,
                firstPin: null,

                acctNo: null,
                branchNo: null,
                bankId: null,                                       
                acctType: null,
                opNo: null,
                isBlocked: false,
                isActive: false,
                notes: null,

                referralCode: null,
            },

            acctTypes: [
				{
					id: 'C',
					name: 'Conta Corrente'
				},
				{
					id: 'P',
					name: 'Conta Poupança'
				}
			]
        }),

        watch: {
            'formData.covenantId' (newValue) {
                if (+newValue === 1) {
                    this.formData.categoryId = 2;
                }
            },
        },

        computed: {
            age() {
                if (this.formData.birth) {
                    return this.$moment().diff(this.formData.birth, 'years', false);
                } else {
                    return null;
                }
            },

            validPhone() {
                return this.formData.mobileNumber && this.formData.mobileNumber.length >= 14;
            },

            birthLabel() {
                if (this.age) {
                    return `Nascimento (${this.age} anos)`;
                }
                return 'Nascimento';
            },

            isBankPayCaixa() {
               return this.formData && (this.formData.bankId === 22);
            },
        },

        methods: {
            copyReferral() {
                window.Clipboard.copy(this.formData.referralCode);

                this.$notifyUser({
                    message: 'Texto Copiado!'
                });
            },

            copyLink(link) {
                window.Clipboard.copy(link);
                this.$notifyUser({
                    message: 'Texto Copiado!'
                });
            },

            async resendEmail(event) {
                event.preventDefault();
                this.loadingSendEmail = true;
                try {
                    let res = await this.$api.dataService.execute('backofficeAffiliate/sendAffiliateEmail', { id: this.formData.id });
                    if (res) {
                        this.$notifyUser({
                            message: 'Email reenviado!'
                        });
                    }
                } catch(err) {
                    //    
                }

                this.loadingSendEmail = false;
            },

            async getReferralCode(event) {
                event.preventDefault();
                this.loadingGenerateLinks = true;

                let res = await this.$api.dataService.execute('backofficeAffiliate/getReferralCode', { id: this.formData.id });
                if(res) {
                    this.referralCode = res.referralCode;
                }

                this.loadingGenerateLinks = false;
            },

            download(event) {
                event.preventDefault();

                var link = document.createElement('a');
                link.download = `qrcode-${this.formData.name.split(" ")[0].toString().toLowerCase()}-${this.selectedProduct}.png`;
                link.href = document.querySelector('.affiliate-qr-code > canvas').toDataURL();
                link.click();

                this.$notifyUser({
                    message: 'QRCode baixado!'
                });
            },

            toggleModal(product, link) {
                if (document.querySelector(".modal-container-qrcode").classList.contains('show')) {
                    document.querySelector(".modal-container-qrcode").classList.remove('show');
                    document.querySelector(".modal-container-qrcode").classList.add('hidden');
                } else {
                    this.selectedProduct = product;
                    document.querySelector('.affiliate-qr-code').innerHTML = '';
                    QrCreator.render({
                        text: link,
                        radius: 0.0,
                        ecLevel: 'L',
                        fill: '#000000',
                        background: '#FFFFFF',
                        size: 200
                    }, document.querySelector('.affiliate-qr-code'));

                    document.querySelector(".modal-container-qrcode").classList.remove('hidden');
                    document.querySelector(".modal-container-qrcode").classList.add('show');
                } 
            }
        },
    });
</script>

<style scoped>
    h4 {
        color: black;
        font-weight: bold;
    }

    .btn {
        width: 100%;
        background-color: #4744e9;
        border-radius: 5px;
        padding: 20px;
        margin-top: 10px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
        cursor: pointer;
        transition: .2s;
        font-size: 16px;
    }

    .btn:first-child {
        margin-right: 10px;
    }

    .btn:last-child {
        margin-left: 10px;
    }

    .btn:hover {
        background-color: #3b39ca;
    }

    .links {
        margin-top: 25px;
    }

    .links > h5 {
        color: black;
    }

    .links > .link-card {
        width: 100%;
        background-color: #FFF;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
        padding: 15px;
        margin-top: 10px;
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
    }

    .links > .link-card > div > p:last-child {
        margin: 0;
        font-size: 12px;
        color: #555;
    }

    .link-title {
        margin: 0;
        color: #4744e9;
    }

    .links > .link-card > div > .link-copy {
        margin-right: 10px;
    }

    .qr-code {
        margin-top: 25px;
    }

    .modal-container-qrcode {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #2626262f;
        z-index: 1000;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal-container-qrcode.hidden {
        visibility: hidden;
    }

    .modal-container-qrcode.show {
        visibility: visible;
    }

    .modal-content-qrcode {
        height: auto;
        padding: 30px;
        background-color: #FFF;
        border-radius: 10px;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .25);
        display: flex;
        align-items: flex-end;
        justify-content: center;
        flex-direction: column;
    }

    .modal-content-header {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .modal-content-header > h4 {
        color: #4744e9;
        font-weight: bold;
    }

    .download-qrcode {
        width: 100%;
        height: 40px;
        background-color: #4744e9;
        margin-top: 10px;
        border-radius: 3px;
    }

    .invalid-account {
        width: 100%;
        background-color: var(--danger-background-color);
        margin: 0 15px 15px 15px;
        padding: 20px;
        border-radius: 5px;
        color: black;
    }

    .invalid-account p {
        font-size: 14px;
        margin: 0;
    }

    .invalid-account > div {
        margin-top: 3px;
    }

    .invalid-account > div:first-child {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 0;
        color: var(--danger-color);
    }

    .invalid-account > div:nth-child(2) {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .invalid-account > div:nth-child(2) > p:first-child {
        font-weight: bold;
        margin-right: 3px;
    }

    .invalid-account > div:last-child {
        margin-top: 10px;
    }

    .invalid-account > div > i {
        margin-right: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/AffiliateForm.vue